import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CButtonClassname, EButtonColor, Section, SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import './FeedbackSection.scss';

export interface IExpertFeedbackProps {
  title: string;
  description: string;
  imgSrc: string;
}

export const ExpertFeedback: React.FC<IExpertFeedbackProps> = ({ description, imgSrc, title }) => (
  <div className="feedback-widget" data-testid="feedback-widget">
    <img className="feedback-avatar" alt={title} src={imgSrc} />
    <div>
      <h3 className="nn-button-medium">{title}</h3>
      <p>{description}</p>
    </div>
  </div>
);

const experts: IExpertFeedbackProps[] = [
  {
    title: 'prereg:Registration.FeedbackSection.Expert.Title',
    description: 'prereg:Registration.FeedbackSection.Expert.Description',
    imgSrc: `${ENV.AssetsBaseUrl}/feature/falkenstein.png`,
  },
];

export interface IUserFeedbackProps {
  description: string;
  name: string;
  imgSrc: string;
}

export const UserFeedback: React.FC<IUserFeedbackProps> = ({ description, imgSrc, name }) => {
  const { t } = useTranslation();
  return (
    <div className="feedback-widget" data-testid="feedback-widget">
      <img className="feedback-avatar" alt={t(name) ?? ''} src={imgSrc} />
      <div>
        <small className="user-feedback-label">{t('prereg:Registration.FeedbackSection.MemberFeedback')}</small>
        <h3 className="nn-button-medium">
          {t(name)}
          <span className="feedback-rating">
            <FontAwesomeIcon color="#ffd800" icon={faStar} />
            <FontAwesomeIcon color="#ffd800" icon={faStar} />
            <FontAwesomeIcon color="#ffd800" icon={faStar} />
            <FontAwesomeIcon color="#ffd800" icon={faStar} />
            <FontAwesomeIcon color="#ffd800" icon={faStar} />
          </span>
        </h3>
        <p>{t(description)}</p>
      </div>
    </div>
  );
};

const users: IUserFeedbackProps[] = [
  {
    description: 'prereg:Registration.FeedbackSection.User.Description',
    name: 'prereg:Registration.FeedbackSection.User.Name',
    imgSrc: `${ENV.AssetsBaseUrl}/feature/user-feedback-icon.png`,
  },
];

export interface IFeedbackSection {
  hideRegistrationButton?: boolean;
}

const RootSectionId = 'root';

export const FeedbackSection: React.FC<IFeedbackSection> = ({ hideRegistrationButton }) => {
  const { t } = useTranslation();
  const title = t('prereg:Registration.FeedbackSection.Title');

  const onAnchorClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const anchorTarget = document.getElementById(RootSectionId);
    if (anchorTarget) {
      try {
        anchorTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        anchorTarget.scrollIntoView(true);
      }
    }
  };

  return (
    <Section className="feedback-section">
      <SectionTitle>{title}</SectionTitle>
      <div className="row expert-feedback-container">
        <div className="col-12">
          {experts.map(({ description, imgSrc, title }) => (
            <ExpertFeedback key={title} description={t(description)} imgSrc={imgSrc} title={t(title)} />
          ))}
        </div>
      </div>
      <div className="row user-feedback-container">
        <div className="col-12">
          {users.map(({ description, imgSrc, name }) => (
            <UserFeedback key={name} description={description} imgSrc={imgSrc} name={name} />
          ))}
        </div>
      </div>
      {!hideRegistrationButton && (
        <a
          href={`#${RootSectionId}`}
          onClick={onAnchorClick}
          className={`${CButtonClassname} ${EButtonColor.blue} feedback-action`}>
          {t('prereg:Registration.FeedbackSection.Action')}
        </a>
      )}
    </Section>
  );
};

export default FeedbackSection;
